import HealthRecords from '../sections/healthRecords/healthRecords';

export default function HealthRecordsPage() {
  return (
    <div className="section-page">
      <HealthRecords />
    </div>
  );
}
